// Critically-damped smoothing toward a target — no library (plan/03 §4).
// `halflife` is the time (ms) to close half the remaining distance; the exp form
// is framerate-independent, so it behaves the same at 60 and 120 Hz.
export function damp(current: number, target: number, halflife: number, dt: number): number {
	if (halflife <= 0 || dt <= 0) return target;
	return target + (current - target) * Math.exp((-Math.LN2 * dt) / halflife);
}

export const clamp01 = (x: number): number => (x < 0 ? 0 : x > 1 ? 1 : x);

export const smoothstep = (x: number): number => {
	const t = clamp01(x);
	return t * t * (3 - 2 * t);
};

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
